export const AUTH_KEY = 'auth';
export const USER_KEY = 'user';
export const LANGUAGE_KEY = 'language';
export const ACTIVE_CONTEXT_KEY = 'activeContext';
export const SIDEBAR_KEY = 'sidebar';
export const SENSITIVE_DATA_KEY = 'sensitiveData';
export const LOGGED_OUT_KEY = 'justLoggedOut';
